<template>
  <!--  3-1  医疗机构登录状态首页-->
  <div>
    <div class="top-box-two">
      <!---------------------------------------- 白色导航条 ---------------------------------------->
      <div class="index-top">
        <!-- -----------------左侧logo语言切换----------------- -->
        <div class="logo">
          <!--          <div><img src="./assets/Logo Shapes 42.png" alt="" @click="goToFront" style="  cursor: pointer;" /></div>-->
          <p class="logo-title" @click="goToFront">{{ $t('effortlessCareer') }}</p>
          <!-- 语言切换 -->
          <div class="change-lang">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                {{ language  }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="0">{{ $t("chinese") }}</el-dropdown-item>
                <el-dropdown-item command="1">{{ $t("japanese") }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <!-- ---------------如果登录后展现的top内容--------------- -->
        <div class="login-and-then">
          <button class="job-posting" @click="goToOther">{{ $t('homepost') }}</button>
          <div class="mask">
            <img :src="urlImgInfo" @error="imgError" alt="" />
            <div>
              {{ itemData.userName }}
            </div>
          </div>
          <!--          <div class="top-icon-login" @click="goToMes(1)">-->
          <!--            <img src="./assets/bi_chat-left-dots-fill.png" alt="" />-->
          <!--          </div>-->
          <!--          <div class="top-icon-login" @click="goToMes(1)">-->
          <!--            <img src="./assets/ic_round-notifications.png" alt="" />-->
          <!--          </div>-->
        </div>
      </div>
      <!-- ------------------------------------白色导航条结束------------------------------------ -->
      <!-- --------------------------------------蓝色搜索栏-------------------------------------- -->
      <div class="box-main-big-css1">
        <!-- -----------------------------------------白色导航条----------------------------------------- -->

        <div class="search">
          <div class="search-title">
            <div class="search-title-main">{{ $t('largestStaffing') }}</div>
            <div class="search-main">
              <el-input placeholder="医療機関、教育機関、求人案件、人材などをここで検索" @input="searchInput" v-model="occupations" type="text"
                class="search-input">
                <i slot="suffix" class="el-input__icon el-icon-search"></i>
              </el-input>
              <button class="search-button" @click="searchClick">{{ $t('search') }}</button>
            </div>
            <!--          <img src="./assets/index-img.png" alt="" class="search-img" />-->
          </div>
        </div>
      </div>
      <!-- -----------------------------------蓝色搜索部分结束----------------------------------- -->
    </div>
    <!-- -----------------------------------主要信息展示部分----------------------------------- -->
    <div class="main-information">
      <!------------------- 主要信息上面类似button提示部分----------------- -->
      <div class="main-top">
        <button :class="
          activeButtonShow ? 'main-top-button-normal' : 'main-top-button-css'
        " @click="buttonOneShow">
          {{ $t('educationalInstitution') }}
        </button>
        <button :class="
          activeButtonShow ? 'main-top-button-css' : 'main-top-button-normal'
        " @click="buttonTwoShow">
          {{ $t('talentPool') }}
        </button>
      </div>
      <!-- -------------------------------信息展示部分------------------------------- -->
      <div class="information-main" v-if="educateIsShow">
        <!-- --------------左侧-------------- -->
        <div class="seeking-square" v-if="educateLeftShow">
          <!-- box agin -->
          <div :class="index1 === indexShow ? 'inform-box-active' : 'inform-box'"
            @click="educateDetailShow(item1.educationId,index1)" v-for="(item1,index1) in schoolList" :key="index1">
            <div class="classification">{{ $t('seniorSchool') }}</div>
            <div class="talent-title">{{ item1.educationName }}
              <!--               认证标签判断-->
              <!--                <div class="form-button">  <button >{{$t('certified')}}</button>  </div>-->
              <el-button class="form-button" type="text" v-if="item1.certifiyStatus=='0'">
                <button>{{ $t('certified') }}</button>
              </el-button>
            </div>
            <p class="company-name">{{ item1.address }}</p>
            <p class="company-name" v-if="language==='CN'">{{ $t('studentNumber') }}　{{ item1.studentNumber_dictText }}
            </p>
            <p class="company-name" v-if="language==='JP'">{{ $t('studentNumber') }}　{{ item1.jpstudentNumber_dictText
              }}</p>

            <p class="company-name" v-if="language==='CN'">{{ $t('employeesNumber') }}　{{ item1.teacherNumber_dictText
              }}</p>
            <p class="company-name" v-if="language==='JP'">{{ $t('employeesNumber') }}　{{ item1.jpteacherNumber_dictText
              }}</p>
            <div class="work-content1">
              {{ $t('businessIntroduction') }}：{{ item1.introduction }}
            </div>
            <p class="last-login">{{ item1.loginDate }}</p>
          </div>
          <!-- box over -->
        </div>
        <!-- --------------右侧-------------- -->
        <div class="seeking-square" v-if="educateRightShow">
          <!-- box agin -->
          <div :class="index2 === indexShow ? 'inform-box-active' : 'inform-box'"
            @click="rightEducateDetailShow(item2.educationId,index2)" v-for="(item2, index2) in schoolList2"
            :key="index2">
            <div class="classification">{{ $t('seniorSchool') }}</div>
            <div class="talent-title">{{ item2.educationName }}
              <!--               认证标签判断-->
              <!--                <div class="form-button">  <button >{{$t('certified')}}</button>  </div>-->
              <el-button class="form-button" type="text" v-if="item2.certifiyStatus=='0'">
                <button>{{ $t('certified') }}</button>
              </el-button>
            </div>
            <p class="company-name">{{ item2.address }}</p>
            <p class="company-name" v-if="language==='CN'">{{ $t('studentNumber') }}　{{ item2.studentNumber_dictText }}
            </p>
            <p class="company-name" v-if="language==='JP'">{{ $t('studentNumber') }}　{{ item2.jpstudentNumber_dictText
              }}</p>

            <p class="company-name" v-if="language==='CN'">{{ $t('employeesNumber') }}　{{ item2.teacherNumber_dictText
              }}</p>
            <p class="company-name" v-if="language==='JP'">{{ $t('employeesNumber') }}　{{ item2.jpteacherNumber_dictText
              }}</p>
            <div class="work-content1">
              {{ $t('businessIntroduction') }}：{{ item2.introduction }}
            </div>
            <p class="last-login">{{ item2.loginDate }}</p>
          </div>
          <!-- box over -->
        </div>
        <!-- 详细信息 -->
        <!-- 点击box，左侧出现详细信息 -->
        <div class="seeking-square" ref="menu">

          <div class="seeking-square" v-if="educateDetailsShow" :class="headerFixed?'issFixed':''">
            <div class="recruitment-box-main">
              <div @click="handleButton">
                <div class="recruitment-title">{{ $t('seniorSchool') }}</div>
                <div class="recruitment-box-title1">{{ schoolDetailsList.educationName }}
                  <!--               认证标签判断-->
                  <!--                <div class="form-button">  <button >{{$t('certified')}}</button>  </div>-->
                  <el-button class="form-button" type="text" v-if="schoolDetailsList.certifiyStatus=='0'">
                    <button>{{ $t('certified') }}</button>
                  </el-button>
                </div>
                <p class="company-name">{{ schoolDetailsList.address }}</p>
                <p class="company-name" v-if="language==='CN'">{{ $t('studentNumber') }}　{{
                  schoolDetailsList.studentNumber_dictText }}</p>
                <p class="company-name" v-if="language==='JP'">{{ $t('studentNumber') }}　{{
                  schoolDetailsList.jpstudentNumber_dictText }}</p>
                <p class="company-name" v-if="language==='CN'">{{ $t('employeesNumber') }}　{{
                  schoolDetailsList.teacherNumber_dictText }}</p>
                <p class="company-name" v-if="language==='JP'">{{ $t('employeesNumber') }}　{{
                  schoolDetailsList.jpteacherNumber_dictText }}</p>
              </div>
              <div class="recruitment-box-button">
                <!--进入详情页面-->
                <button class="button1" @click="Click1">{{ $t('goToDetailPage') }}</button>
                <!--收藏-->
                <button class="button2" @click="Click2">{{ $t("collection") }}</button>
                <!--聊天-->
                <button class="button2" @click="Click3">{{ $t("talk") }}</button>
              </div>

              <!-- 滚动部分 -->
              <div class="mask-recruitment">
                <!-- 滚动具体内容 -->
                <div class="recruitment-main-scroll">
                  <div class="recruitment-scroll-img">
                    <img :src="imgList[0]" alt="" />
                    <img :src="imgList[1]" alt="" />
                    <img :src="imgList[2]" alt="" />
                  </div>
                  <!-- 每一长行开始 -->
                  <div class="specific-main-long">
                    <div class="long-box">
                      <div class="long-box-title">{{ $t("businessContent") }}</div>
                      <div class="long-box-main">
                        {{ schoolDetailsList.introduction }}
                      </div>
                    </div>
                  </div>

                  <!-- 每一长行结束 -->
                  <!-- 表格内容 -->
                  <div class="student-table">
                    <div class="student-table-top">{{ $t("student") }}</div>
                    <!-- 表格 -->
                    <div>
                      <el-table :data="tableData" @row-click="jump" height="340" style="width: 100%">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="userName" label="氏名" :show-overflow-tooltip="true">
                          <template slot="header" slot-scope="scope">
                            <p>{{$t("name")}}</p>
                            <el-input v-model="search1" size="mini" placeholder="Search" class="table-input" />
                          </template>
                          <template slot-scope="scope">
                            {{scope.row.name}}
                          </template>
                        </el-table-column>
                        <el-table-column prop="sex" label="性別" width="80" :show-overflow-tooltip="true">
                          <template slot="header" slot-scope="scope">
                            <p>{{$t("sex")}}</p>
                            <el-input v-model="search2" size="mini" placeholder="Search" class="table-input" />
                          </template>
                          <template slot-scope="scope">
                            <span v-if="language==='CN'">
                              {{ scope.row.sex_dictText }}
                            </span>
                            <span v-else>
                              {{ scope.row.jpsex_dictText }}
                            </span>
                          </template>
                        </el-table-column>
                        <el-table-column prop="time" label="生年月日" width="150" :show-overflow-tooltip="true">
                          <template slot="header" slot-scope="scope">
                            <p>{{$t("birth")}}</p>
                            <el-input v-model="search3" size="mini" placeholder="Search" class="table-input" />
                          </template>
                          <template slot-scope="scope">
                            {{scope.row.birth.split(" ")[0]}}
                          </template>
                        </el-table-column>
                        <el-table-column prop="education" label="学歴" width="100" :show-overflow-tooltip="true">
                          <template slot="header" slot-scope="scope">
                            <p>{{$t("education")}}</p>
                            <el-input v-model="search4" size="mini" placeholder="Search" class="table-input" />
                          </template>
                          <template slot-scope="scope">
                            <span v-if="language==='CN'">
                              {{ scope.row.education_dictText }}
                            </span>
                            <span v-else>
                              {{ scope.row.jpeducation_dictText }}
                            </span>
                          </template>
                        </el-table-column>
                        <el-table-column prop="specialize" label="専攻" width="120" :show-overflow-tooltip="true">
                          <template slot="header" slot-scope="scope">
                            <p>{{$t("major")}}</p>
                            <el-input v-model="search5" size="mini" placeholder="Search" class="table-input" />
                          </template>
                          <template slot-scope="scope">
                            {{scope.row.profession}}
                          </template>
                        </el-table-column>
                        <el-table-column prop="lang" label="日本語" :show-overflow-tooltip="true">
                          <template slot="header" slot-scope="scope">
                            <p>{{$t("japanese")}}</p>
                            <el-input v-model="search6" size="mini" placeholder="Search" class="table-input" />
                          </template>
                          <template slot-scope="scope">
                            <span v-if="language==='CN'">
                              {{ scope.row.japanese_dictText }}
                            </span>
                            <span v-else>
                              {{ scope.row.jpjapanese_dictText }}
                            </span>
                          </template>
                        </el-table-column>
                      </el-table>
                      <div class="pagination-css">
                        <el-pagination layout="prev, pager, next, sizes" :total=tableTotal
                          :page-sizes="[5, 10, 15, 20] " :page-size=tablePageSize :current-page="currentPage"
                          @size-change="handleSizeChange" @current-change="handleCurrentChange" class="pagination">
                        </el-pagination>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 滚动具体内容结束 -->
              </div>
              <!-- 滚动部分结束 -->
              <!-- 返回按键 -->
              <div class="disappear-box">
                <img src="./assets/Arrow_Right_LG.png" alt="" @click="returnNormal" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- -------------------------------人才展示部分------------------------------- -->
      <div class="information-main">
        <div class="seeking-square" v-if="talentIsShow" v-for="(item2, index2) in talentList" :key="index2">
          <!-- box agin -->
          <div class="inform-box" @click="talentDetailShow(item2.resumeId)">
            <div class="classification">{{$t("talent")}}</div>
            <div class="talent-title">{{ item2.name }}</div>
            <div class="company-name">
              <p v-if="lang === 'JP'">{{$t("sex")}}:　{{item2.jpsex_dictText}}</p>
              <p v-else>{{$t("sex")}}：　{{item2.sex_dictText}}</p>
            </div>
            <p class="company-name">{{$t("birth")}}:　{{ item2.birth.split(" ")[0] }}</p>
            <div class="company-name">
              <p v-if="lang === 'JP'">{{$t("japanese")}}:　{{item2.jpjapanese_dictText}}</p>
              <p v-else>{{$t("japanese")}}：　{{item2.japanese_dictText}}</p>
            </div>
            <div class="work-content1">
              {{$t("selfPR")}}:{{ item2.pr }}
            </div>
            <p class="last-login">{{ item2.loginDate }}（{{ $t("postTheLastLoginTimeOfThePostLeader") }}）</p>
          </div>
          <!-- box over -->
        </div>
      </div>

    </div>

    <!-- 模糊搜索无结果弹出层 -->
    <div class="search-dialog" v-if="searchShow">
      <div class="dialog-main">
        <p class="box">{{ $t("noResults") }}</p>
        <button class="dialog-button" @click="close">
          {{ $t("close") }}
        </button>
      </div>
    </div>

    <div class="el-icon-loading-icon" v-if="iconLoadingIsShow">
      <i class="el-icon-loading" style="margin-right: 10px;"></i>{{$t('loadingWord')}}
    </div>
    <div class="el-icon-loading-icon" v-if="moreDataShow">
      {{$t('noMoreData')}}
    </div>

  </div>
</template>

<script>
  import {
    schoolListQuery,
    schoolDetailsQuery,
    talentListQuery,
    getUrlFromOSS,
    insertMedicalCollection,
    fuzzyCaseAndMedicalQuery2
  } from "../../js/api";
  import AES from "../../js/AES";
  import axios from "axios";
  export default {
    name: "loginFront",
    components: {},
    data () {
      return {
        lang: "JP",
        educationId: "",
        teacherNumber: "",
        introduction: "",
        loginDate: "",
        activeButtonShow: true, //button标识
        educateIsShow: true, //教育机构标识
        educateLeftShow: true, //教育机构左侧标识
        educateRightShow: true, //教育机构右侧标识
        educateDetailsShow: false, //教育机构详情标识
        talentIsShow: false, //人才信息标识
        tableIsShow: false, //table标识
        occupations: "", // 关键词，职业等
        tableData: [], //table信息
        currentPage: 1, //当前页面
        pageSize: 200,
        tablePageSize: 5,
        tableTotal: 0,
        schoolList: [],
        schoolList2: [],
        talentList: [],
        schoolDetailsList: [],
        itemData: {},
        urlImgInfo: "",
        search1: "",
        search2: "",
        search3: "",
        search4: "",
        search5: "",
        search6: "",
        schoolQuery: [],
        data1: [],
        data2: [],
        imgList: [],
        indexShow: "",
        offsetTop: 0,
        offsetHeight: 0,
        headerFixed: 0,
        searchShow: false,
        allSchoolQueryList: [],
        cerStatus: 1,
        listCurrentPage: 1,
        listPageSize: 8,
        iconLoadingIsShow: true,
        language: "",
        moreDataShow: false

      };
    },
    created () {
      this.language = window.localStorage.getItem('language')
      console.log("语言选择为" + window.localStorage.getItem('language'))
      console.log("页面语言选择为" + this.language)

      this.getAES()
      //查询学校信息(列表)
      this.getSchoolList();
      this.getTalentList();
    },
    computed: {},
    mounted () {
    
      this.$nextTick(() => {
        const menu = this.$refs.menu
        // 吸顶元素到top的距离
        this.offsetTop = menu.offsetTop
        // 元素自身的高度
        this.offsetHeight = menu.offsetHeight
        // 监听滚动条
        window.addEventListener('scroll', this.handleScroll, true)
      })
      window.addEventListener("scroll", this.handleScroll2, true);
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll, true)
      window.removeEventListener('scroll', this.handleScroll2, true)
   
    },
  
    methods: {
    
      imgError (e) {

        e.target.src = require('@/assets/avatar.png')
      },
      close () {
        this.searchShow = false;
      },
      searchInput (e) {
        if (e === '') {
          this.listCurrentPage = 1
          this.listPageSize = 8
          this.getSchoolList()

          this.getTalentList()

        }
      },
      //判断 是否到底部
      handleScroll2 () {
        let scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop // 变量windowHeight是可视区的高度
        let windowHeight =
          document.documentElement.clientHeight || document.body.clientHeight // 变量scrollHeight是滚动条的总高度
        let scrollHeight =
          document.documentElement.scrollHeight || document.body.scrollHeight
        console.log(scrollTop, windowHeight, scrollHeight)
        if (scrollTop + windowHeight  >=  scrollHeight) {
          console.log('-----------------------------下拉刷新')
          this.iconLoadingIsShow = true
          this.listPageSize = this.listPageSize + 8
          if (this.occupations === ''&&!this.moreDataShow) {
            if (this.educateIsShow === true) {
              this.getSchoolList()
            } else {
              this.getTalentList()
            }
          }
          return false
        }

        if (scrollTop >= 500) {
          this.iconLoadingIsShow = true
        } else if (scrollTop < 500) {
          this.moreDataShow = false;
          this.iconLoadingIsShow = false; //小于480时隐藏元素
        }
      },
      //详情固定
      handleScroll () {
        const scrollTop = window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop
        this.headerFixed = scrollTop > this.offsetTop - this.offsetHeight
      },
      //页面刷新
      goToFront () {
        location.reload()
      },
      //消息跳转
      goToMes (item) {
        this.$router.push("/medicalInstitutionNewsView");
      },
      //添加案件跳转
      goToOther () {
        if (this.itemData.roleName === "medicalinstitutionadmin") {
          this.$router.push("/administratorMedicalInstitutionRequestingCasesViewManagementList");
        }
        else {
          this.$router.push("/userInformationListOfMedicalInstitutionsSeekingApplicants");
        }
      },
      // 获取头部信息
      getAES () {
        var userInfo = localStorage.getItem("userInfo")
        const aesFecInfo = JSON.parse(AES.decrypt(userInfo));
        console.log("---------------userInfo---------------")
        console.log(aesFecInfo)
        this.itemData = aesFecInfo
        this.getUrl()
      },
      // 头像回显
      getUrl () {
        var fakeInfo = {
          message: this.itemData.avatar
        }
        getUrlFromOSS(fakeInfo).then((res) => {
          console.log("-----------头像回显-----------")
          if (res.data.code === '200 OK') {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo)
            this.urlImgInfo = aesFecInfo.message
          }
          console.log(res)
        }).catch((res) => {
          console.log("-----------头像回显-----------")
          console.log(res)
        })
      },
      searchClick () {
        var that = this;

        // axios.get('/api//modules-parent/medicalInstitutionTalentSquare/fuzzyCaseAndMedicalQuery',
        //   {
        //     params: {
        //       talentAndSchool: this.occupations
        //     },
        //     headers:{
        //       'content-type': 'application/x-www-form-urlencoded',
        //       "token":localStorage.getItem("token")
        //     }
        //   })
        var fakeInfo = {
          queryCriteria: this.occupations,
          pageNumber: this.listCurrentPage,
          pageSize: this.listPageSize,
        }

        fuzzyCaseAndMedicalQuery2(fakeInfo).then((res) => {

          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------模糊匹配人才信息和学校信息接口数据--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo)
            that.allSchoolQueryList = aesFecInfo.data2

            //首次判空
            if (that.educateIsShow === true) {
              if (aesFecInfo.data2.length === 0 && aesFecInfo.data1.length === 0) {
                that.searchShow = true;
              }
              else if (aesFecInfo.data2.length === 0 && aesFecInfo.data1.length !== 0) {
                that.activeButtonShow = false;
                that.talentIsShow = true;
                that.educateIsShow = false;
                that.searchShow = false;
              }
              else if (aesFecInfo.data2.length !== 0 && aesFecInfo.data1.length === 0) {
                that.searchShow = false;
              }
              else {
                that.searchShow = false;
              }
            }
            else if (that.talentIsShow === true) {
              if (aesFecInfo.data2.length === 0 && aesFecInfo.data1.length === 0) {
                that.searchShow = true;
              }
              else if (aesFecInfo.data2.length === 0 && aesFecInfo.data1.length !== 0) {
                that.searchShow = false;
              }
              else if (aesFecInfo.data2.length !== 0 && aesFecInfo.data1.length === 0) {
                that.activeButtonShow = true;
                that.educateIsShow = true;
                that.talentIsShow = false;
                that.searchShow = false;
              }
              else {
                that.searchShow = false;
              }
            }

            //学校数组分左右输出
            let e = 0
            let l = 0
            that.schoolList = []
            that.schoolList2 = []
            for (var i = 0; i < aesFecInfo.data2.length; i++) {
              if (i % 2 === 0) {
                that.schoolList[e] = aesFecInfo.data2[i];
                e++;
              } else {
                that.schoolList2[l] = aesFecInfo.data2[i];
                l++;
              }
            }
            that.talentList = aesFecInfo.data1;
          } else {
            console.log("模糊匹配人才信息和学校信息接口数据异常", res)
          }
        })
          .catch((res) => {
            console.log(res);
          });
      },
      //第一个按钮
      buttonOneShow () {
        this.activeButtonShow = true;
        this.moreDataShow = false
        this.talentIsShow = false;
        this.educateIsShow = true;
        this.judgeSearch();
        this.listPageSize = 8

      },
      // 第二个按钮
      buttonTwoShow () {
        console.log('点击')
        this.activeButtonShow = false;
        this.moreDataShow = false
        this.educateIsShow = false;
        this.talentIsShow = true;
        this.judgeSearch();
        this.listPageSize = 8
      },
      // 教育机构点击左box出现详细信息
      educateDetailShow (educationId, index1) {
        this.educateLeftShow = true;
        this.educateRightShow = false;
        this.educateDetailsShow = true;
        this.getSchoolDetails(educationId);
        this.educationId = educationId;
        this.indexShow = index1;
      },
      // 教育机构点击右box出现详细信息
      rightEducateDetailShow (educationId, index2) {
        this.educateLeftShow = false;
        this.educateRightShow = true;
        this.educateDetailsShow = true;
        this.getSchoolDetails(educationId);
        this.educationId = educationId;
        this.indexShow = index2;
      },
      //二次判空
      judgeSearch () {
        if (this.educateIsShow === true) {
          if (this.allSchoolQueryList.length === 0 && this.talentList.length === 0) {
            this.searchShow = true;
          }
          else if (this.allSchoolQueryList.length === 0 && this.talentList.length !== 0) {
            this.searchShow = true;
          }
          else if (this.allSchoolQueryList.length !== 0 && this.talentList.length === 0) {
            this.searchShow = false;
          }
          else {
            this.searchShow = false;
          }
        }
        else if (this.talentIsShow === true) {
          if (this.allSchoolQueryList.length === 0 && this.talentList.length === 0) {
            this.searchShow = true;
          }
          else if (this.allSchoolQueryList.length === 0 && this.talentList.length !== 0) {
            this.searchShow = false;
          }
          else if (this.allSchoolQueryList.length !== 0 && this.talentList.length === 0) {
            this.searchShow = true;
          }
          else {
            this.searchShow = false;
          }
        }

      },
      //图片回显
      getUrl3 (url) {
        this.imgList = []
        var fakeInfo = {
          message: url
        }
        getUrlFromOSS(fakeInfo).then((res) => {
          if (res.data.code === "200 OK") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            // console.log(aesFecInfo);
            this.imgList.push(aesFecInfo.message);
          }
        }).catch(() => {
        })
      },
      //人才点击详情跳转传参
      talentDetailShow (resumeId) {
        this.$router.push({
          path: '/medicalInstitutionTalentInformationViewPublic',
          name: 'medicalInstitutionTalentInformationViewPublic',
          params: {
            resumeId: resumeId,
          }
        });
      },
      Click1 () {
        this.$router.push({
          path: '/medicalViewEducationHomepage',
          name: 'medicalViewEducationHomepage',
          params: {
            educationId: this.educationId
          }
        });
      },
      Click2 () {
        var fakeInfo = {
          systemEventId: this.educationId,
          systemTypeId: 1,
        }
        insertMedicalCollection(fakeInfo).then((res) => {
          console.log("医疗机构新增收藏接口", res)
          if (res.data.code === "A0000") {
            this.$message({
              message: '收藏成功！',
              type: 'success'
            });
            this.$router.push({
              path: '/medicalFavouritesEducationalInstitutionsViewList',
              name: 'medicalFavouritesEducationalInstitutionsViewList',
              params: {
              }
            });
          } else if (res.data.code === "A0506") {
            this.$message({
              message: '该机构已被收藏！',
              type: 'warning'
            });
          } else {
            this.$message.error('提交错误！');
          }
        }).catch((res) => {
          console.log("医疗机构新增收藏接口异常", res)
        })

      },
      Click3 () {
        this.$router.push({
          path: '/medicalViewEducationHomepage',
          name: 'medicalViewEducationHomepage',
          params: {
            educationId: this.educationId
          }
        });
      },
      handleButton () {
        this.$router.push({
          path: '/medicalViewEducationHomepage',
          name: 'medicalViewEducationHomepage',
          params: {
            educationId: this.educationId
          }
        });
      },
      jump (row, event, column) {
        this.$router.push({
          path: '/medicalInstitutionTalentInformationViewPublic',
          name: 'medicalInstitutionTalentInformationViewPublic',
          params: {
            resumeId: row.resumeId,
          }
        });
      },
      //详情返回信息
      returnNormal () {
        this.educateLeftShow = true;
        this.educateRightShow = true;
        this.educateDetailsShow = false;
        this.indexShow = "";
      },
      // 分页点击操作
      handleSizeChange (val) {
        console.log(`每页 ${val} 条`);
        this.currentPage = 1;
        this.tablePageSize = val;
        this.getSchoolDetails(this.educationId);
      },
      handleCurrentChange (val) {
        this.currentPage = val;
        this.getSchoolDetails(this.educationId);
        console.log(`当前页: ${val}`);
      },
      //切换语言
      handleCommand (command) {
        if (command === "0") {
          this.$i18n.locale = "zh-CN";
          this.lang = "CN";
          this.language = "CN";
        } else {
          this.$i18n.locale = "ja-JP";
          this.lang = "JP";
          this.language = "JP";
        }
      },
      // 接口
      getSchoolList () {
        var fakeInfo = {
          pageNumber: this.listCurrentPage,
          pageSize: this.listPageSize,
        }
        schoolListQuery(fakeInfo).then((res) => {
          console.log("查询学校信息(列表)接口数据", res)
          const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
          console.log(aesFecInfo)
          this.allSchoolQueryList = aesFecInfo.data

          console.log(this.allSchoolQueryList)
          console.log(aesFecInfo.data.length)

          if (aesFecInfo.data.length === aesFecInfo.total) {
            this.moreDataShow = true
          }
          if (aesFecInfo.data.length > 0) {
            this.searchShow = false
          }
          let e = 0
          let l = 0
          this.schoolList = []
          this.schoolList2 = []
          if(this.educateDetailsShow===true){
            this.schoolList= aesFecInfo.data
            this.schoolList2= aesFecInfo.data
          }else{

        
          for (var i = 0; i < aesFecInfo.data.length; i++) {
            if (i % 2 === 0) {
              this.schoolList[e] = aesFecInfo.data[i];
              e++;
            } else {
              this.schoolList2[l] = aesFecInfo.data[i];
              l++;
            }
          }
        }
        }).catch((res) => {
          console.log("查询学校信息(列表)数据异常", res)
        })
      },
      getTalentList () {
        var fakeInfo = {
          pageNumber: this.listCurrentPage,
          pageSize: this.listPageSize,
        }
        talentListQuery(fakeInfo).then((res) => {
          console.log("查询人才信息(列表)接口数据", res)

          const aesFecInfo2 = JSON.parse(AES.decrypt(res.data.data));
          if (aesFecInfo2.data.length === aesFecInfo2.total) {
            this.moreDataShow = true
          }
          if (aesFecInfo2.data.length > 0) {
            this.searchShow = false
          }
          console.log(aesFecInfo2)
          this.talentList = aesFecInfo2.data;
        }).catch((res) => {
          console.log("查询人才信息(列表)数据异常", res)
        })
      },
      getSchoolDetails (educationId) {
        this.educationId = educationId;
        var fakeInfo = {
          educationId: this.educationId,
          pageNumber: this.currentPage,
          pageSize: this.tablePageSize,

        }
        schoolDetailsQuery(fakeInfo).then((res) => {
          console.log("查询学校信息(详情)接口数据", res)
          const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
          console.log(aesFecInfo)
          this.schoolDetailsList = aesFecInfo.data1[0];
          this.tableData = aesFecInfo.data2;

          this.tableTotal = aesFecInfo.data2.length;
          this.getUrl3(aesFecInfo.data1[0].pictuer1);
          this.getUrl3(aesFecInfo.data1[0].pictuer2);
          this.getUrl3(aesFecInfo.data1[0].pictuer3);
        }).catch((res) => {
          console.log("查询学校信息(详情)数据异常", res)
        })
      },
    },

  };
</script>
<style scoped>
  .top-box-two {
    height: 80px;
    background: transparent;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    min-width: 1349px;
    z-index: 10;
  }

  .box-main-big-css1 {
    height: 320px;
    background: transparent;
    position: absolute;
    min-width: 1349px;
    top: 64px;
    left: 0;
    right: 0;
    z-index: 9;
  }

  .index-top {
    height: 64px;
    /* width: 100vw; */
    /* min-width: 1349px; */
    padding: 16px 35px;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
  }

  .logo {
    width: 250px;
    display: flex;
  }

  .logo-title {
    font-family: "Mochiy Pop One";
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 35px;
    text-align: center;
    letter-spacing: -0.02em;
    color: #686868;
    margin: 0 5px;
    cursor: pointer;
  }

  .change-lang {
    margin-top: 15px;
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 13.6333px;
    line-height: 16px;
    align-items: center;
    letter-spacing: 0.639063px;
    color: #686868;
  }

  .login-and-then {
    flex: 1;
    overflow: hidden;
  }

  .mask {
    float: right;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: #686868;
    line-height: 32px;
    margin: 0px 4px;
    display: flex;
  }

  .mask img {
    width: 28px;
    height: 28px;
    text-align: center;
    border-radius: 50%;
    margin-right: 10px;
    overflow: hidden;
  }

  .top-icon-login {
    float: right;
    line-height: 32px;
  }

  .top-icon-login img {
    width: 24px;
    cursor: pointer;
    height: 24px;
    margin-right: 20px;
  }

  .job-posting {
    float: right;
    width: 100px;
    height: 30px;
    box-sizing: border-box;
    align-items: center;
    background: #51abff;
    border-radius: 4px;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    margin-left: 16px;
    cursor: pointer;
  }

  .search {
    height: 320px;
    /* width: 100vw; */
    /* min-width: 1349px; */
    background: #51abff;
    /* min-width: 1349px; */
  }

  .search-title {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    height: 320px;
    margin: 0 auto;
    padding: 43px 100px;
    box-sizing: border-box;
    position: relative;
  }

  .search-title-main {
    margin-top: 70px;
    margin-bottom: 15px;
    font-family: "Mochiy Pop P One";
    font-style: normal;
    font-weight: 400;
    font-size: 56px;
    line-height: 24px;
    color: #e5e5e5;
    height: 70px;
  }

  .search-main {
    width: 720px;
    height: 80px;
    background: #fafafa;
    border-radius: 8px;
    padding: 20px 16px;
    box-sizing: border-box;
  }

  .search-input {
    padding: 0 10px;
    width: 560px;
    height: 40px;
    box-sizing: border-box;
    margin-right: 15px;
  }

  .search /deep/ .el-input__inner {
    width: 560px;
    height: 40px;
    background: #fafafa;
    border: 1px solid #686868;
    box-sizing: border-box;
    border-radius: 8px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    font-feature-settings: "salt" on, "liga" off;
    color: #686868;
  }

  .el-icon-search {
    font-size: 16px;
    font-weight: 600;
    color: #000;
  }

  .el-icon-location-outline {
    font-size: 18px;
    font-weight: 600;
    color: #000;
  }

  .search-button {
    height: 40px;
    width: 80px;
    margin-left: 20px;
    box-sizing: border-box;
    background: #fc630c;
    cursor: pointer;
    border-radius: 8px;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    font-feature-settings: "salt" on, "liga" off;
    color: #ffffff;
  }

  .search-img {
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .main-information {
    overflow: hidden;
    width: 1349px;
    left: 0;
    right: 0;
    margin: 0 auto;
    position: absolute;
    top: 0;

  }

  .main-top {
    margin-top: 384px;
    height: 76px;
    /* width: 100vw;
   */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    cursor: pointer;
  }

  .main-top-button-normal {
    width: 300px;
    height: 40px;
    background: #51abff;
    border-radius: 8px;
    font-family: "Roboto";
    font-style: normal;
    cursor: pointer;
    font-weight: 400;
    font-size: 18px;
    font-feature-settings: "salt" on, "liga" off;
    color: #ffffff;
    margin-left: 40px;
  }

  .main-top-button-css {
    background: #fafafa;
    border: 1px solid #51abff;
    width: 300px;
    height: 40px;
    border-radius: 8px;
    font-family: "Roboto";
    font-style: normal;
    cursor: pointer;
    font-weight: 400;
    font-size: 18px;
    font-feature-settings: "salt" on, "liga" off;
    color: #51abff;
    margin-left: 40px;
  }

  .information-main {
    box-sizing: border-box;
    display: flex;
    flex-flow: wrap;
    width: 1100px;
    margin: 0 auto 20px;
  }

  .inform-box {
    width: 480px;
    height: 360px;
    padding: 20px 30px;
    box-sizing: border-box;
    border: 1px solid #c9cfda;
    box-sizing: border-box;
    border-radius: 8px;
    background: #fff;
    margin: 15px 40px;
    cursor: pointer;
  }

  .inform-box-active {
    width: 480px;
    height: 360px;
    padding: 20px 30px;
    box-sizing: border-box;
    border: 1px solid #51abff;
    box-sizing: border-box;
    border-radius: 8px;
    background: #fff;
    margin: 15px 40px;
    cursor: pointer;
  }

  .seeking-square {
    width: 550px;

  }

  .talent-pool {

    width: 550px;
  }

  .talent-pool-fixed {
    position: fixed;
    width: 550px;
    right: calc(50% - 550px);
    top: 0;
  }

  .classification {
    height: 32px;
    line-height: 32px;
    width: 280px;
    border-radius: 8px;
    padding-left: 10px;
    box-sizing: border-box;
    background: #e8edf1;
    border-radius: 8px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: left;
    color: #686868;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .box-title {
    height: 60px;
    margin-top: 15px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 30px;
    color: #000000;
    padding: 0 5px;
    box-sizing: border-box;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  .company-name {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    color: #000000;
    margin-top: 4px;
    padding: 0 5px;
    box-sizing: border-box;
  }

  .box-mini {
    height: 30px;
    padding-top: 4px;
    box-sizing: border-box;
    display: flex;
    margin-top: 5px;
  }

  .mini-box-main {
    padding: 0 5px;
    line-height: 24px;
    text-align: center;
    border: 1px solid rgba(104, 104, 104, 0.8);
    box-sizing: border-box;
    border-radius: 8px;
    margin: 0px 4px;
  }

  .work-content {
    height: 65px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #686868;
    padding: 0 5px;
    box-sizing: border-box;
    margin-top: 8px;
    box-sizing: border-box;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }

  .last-login {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #686868;
    padding: 0 5px;
    box-sizing: border-box;
  }

  .inform-box {
    width: 480px;
    height: 360px;
    padding: 20px 30px;
    box-sizing: border-box;
    border: 1px solid #c9cfda;
    box-sizing: border-box;
    border-radius: 8px;
    background: #fff;
    margin: 15px 40px;
    cursor: pointer;
  }

  .seeking-square {
    width: 550px;
  }

  .talent-pool {
    width: 550px;
  }

  .classification {
    height: 32px;
    line-height: 32px;
    width: 230px;
    border-radius: 8px;
    padding-left: 10px;
    box-sizing: border-box;
    background: #e8edf1;
    border-radius: 8px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: left;
    color: #686868;
  }

  .box-title {
    height: 60px;
    margin-top: 15px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 30px;
    color: #000000;
    padding: 0 5px;
    box-sizing: border-box;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  .company-name {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    color: #000000;
    margin-top: 4px;
    padding: 0 5px;
    box-sizing: border-box;
  }

  .box-mini {
    height: 30px;
    padding-top: 4px;
    box-sizing: border-box;
    display: flex;
    margin-top: 5px;
  }

  .mini-box-main {
    width: 58px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    border: 1px solid rgba(104, 104, 104, 0.8);
    box-sizing: border-box;
    border-radius: 8px;
    margin: 0px 4px;
  }

  .work-content {
    height: 65px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #686868;
    padding: 0 5px;
    box-sizing: border-box;
    margin-top: 8px;
    box-sizing: border-box;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }

  .last-login {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #686868;
    padding: 0 5px;
    box-sizing: border-box;
  }

  .talent-title {
    height: 70px;
    line-height: 70px;
    padding: 0 5px;
    box-sizing: border-box;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    color: #000;
    display: flex;

  }

  .work-content1 {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #686868;
    padding: 0 5px;
    box-sizing: border-box;
    margin-top: 8px;
    height: 120px;
    overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;


  }

  .recruitment-box-main {
    height: 770px;
    width: 521px;
    border-radius: 8px;
    border: 1px solid #c9cfda;
    box-sizing: border-box;
    border-radius: 8px;
    margin: 15px 0;
    padding: 7px 25px 7px 20px;
    box-sizing: border-box;
    position: relative;
  }

  .recruitment-title {
    height: 32px;
    line-height: 32px;
    width: 220px;
    background: #e8edf1;
    border-radius: 8px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #686868;
    margin-top: 20px;
    padding-left: 10px;
  }

  .recruitment-box-title {
    height: 58px;
    width: 415px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    color: #000000;
    margin-top: 12px;
  }

  .recruitment-box-button {
    margin-top: 24px;
    padding-left: 20px;
    box-sizing: border-box;
    display: flex;
    height: 40px;
  }

  .recruitment-box-button .button1 {
    width: 200px;
    height: 40px;
    background: #51abff;
    border-radius: 8px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
    cursor: pointer;
  }

  .recruitment-box-button .button2 {
    width: 100px;
    height: 40px;
    background: #fafafa;
    border: 1px solid #51abff;
    box-sizing: border-box;
    border-radius: 8px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    color: #51abff;
    cursor: pointer;
    margin-left: 12px;
  }

  .mask-recruitment {
    width: 470px;
    height: 480px;
    margin-top: 30px;
    overflow: hidden;
  }

  .recruitment-main-scroll {
    width: 490px;
    padding-right: 20px;
    box-sizing: border-box;
    height: 480px;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .recruitment-scroll-img {
    width: 470px;
    height: 115px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .box-introduce {
    height: 30px;
    display: flex;
    padding-left: 20px;
    box-sizing: border-box;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .box-introduce-main {
    background: #fc630c;
    border-radius: 4px;
    padding: 0 10px;
    line-height: 30px;
    text-align: center;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
  }

  .specific-contents {
    padding-left: 20px;
    padding-bottom: 20px;
    box-sizing: border-box;
  }

  .specific-main {
    height: 90px;
    display: flex;
    justify-content: space-between;
  }

  .specific-main-box {
    width: 200px;
  }

  .specific-main-top {
    width: 200px;
    height: 45px;
    line-height: 45px;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    color: #686868;
    border-bottom: 1px solid #686868;
  }

  .specific-main-top-title {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #686868;
    height: 45px;
    line-height: 45px;
  }

  .long-box {
    width: 100%;
    height: 130px;
  }

  .long-box-title {
    width: 100%;
    height: 45px;
    line-height: 45px;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    color: #686868;
    border-bottom: 1px solid #686868;
    margin-bottom: 5px;
  }

  .long-box-main {
    height: 80px;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: #686868;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    /*显示的行数*/
    overflow: hidden;
  }

  .disappear-box {
    width: 25px;
    height: 25px;
    position: absolute;
    top: 10px;
    right: 20px;
    cursor: pointer;
  }

  .recruitment-box-title1 {
    height: 60px;
    line-height: 60px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    color: #000000;
    display: flex;

  }

  .student-table {
    height: 460px;
  }

  .student-table-top {
    width: 100%;
    height: 45px;
    line-height: 45px;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    color: #686868;
    border-bottom: 1px solid #686868;
    margin-bottom: 5px;
  }

  .student-table /deep/.cell .table-header1 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #00072b;
    width: 50px;
  }

  .pagination-css {
    height: 30px;
    margin-top: 10px;
  }

  .pagination {
    float: right;
  }

  .talent-pool {
    width: 550px;
  }

  .table-back {
    height: 30px;
  }

  .table-back img {
    float: right;
    cursor: pointer;
  }

  .table-input /deep/ .el-input__inner {
    border: 1px solid transparent;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: #c9cfda;
    padding: 0;
  }

  .issFixed {
    top: -25px;
    margin-left: -15px;
    width: 520px;
    height: 826px;
    padding: 15px 35px 15px 15px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: fixed;
  }

  .search-dialog {
    width: 300px;
    height: 0px;
    position: absolute;
    top: 600px;
    left: 850px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.6);
  }

  .dialog-main {
    width: 498px;
    height: 200px;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 10px 5px -10px rgba(0, 0, 0, 0.1), 0 0 4px 0 rgba(0, 0, 0, 0.1);
  }

  .box {
    margin-top: 50px;
    height: 50px;
    line-height: 24px;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
  }

  .dialog-button {
    margin-top: 30px;
    width: 100px;
    height: 24px;
    line-height: 24px;
    background: #ffffff;
    border: 1px solid #51abff;
    box-sizing: border-box;
    border-radius: 4px;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #51abff;
    cursor: pointer;
  }

  .form-button {
    margin-left: 20px;
    text-align: center;
    display: flex;
    height: 20px;

  }

  .form-button button {
    height: 18px;
    /*line-height: 20px;*/
    width: 50px;
    background: #fc630c;
    border-radius: 1px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    color: #ffffff;
  }

  .el-icon-loading-icon {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;

    height: 20px;
    background: #E8EDF1;
    line-height: 20px;
    text-align: center;
    
  }
</style>


// WEBPACK FOOTER //
// src/pages/MedicalFront/index.vue